<template>
  <div class="youtube panel-settings">
  </div>
</template>

<script>
export default {
};
</script>
